import indexState from "./indexStore/state";
// 公有内容直接写入。
var state = {
    ...indexState
};
export default state;